import Fluxible from 'vendor/cnpm/fluxible.v0-4/index';

import NaptimeStore from 'bundles/naptimejs/stores/NaptimeStore';
import ApplicationStore from 'bundles/ssr/stores/ApplicationStore';
// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import routes from 'bundles/workspaces-app/app/routes';

import 'css!bundles/global-styles/global-element-styles';

const app = new Fluxible({
  component: routes,
});

app.registerStore(ApplicationStore);
app.registerStore(NaptimeStore);

export default app;
